import React from 'react';
import { useTranslation } from 'react-i18next';
import LeaderboardEmptyStateSecond from '../../svgs/gfm_leaderboard/LeaderboardEmptyStateSecond';
import LeaderboardEmptyFirstPlace from '../../svgs/gfm_leaderboard/LeaderboardEmptyFirstPlace';
import LeaderboardEmptyStateThird from '../../svgs/gfm_leaderboard/LeaderboardEmptyStateThird';
import * as Styled from './GfmLeaderboardEmptyState.styled';
import * as Shared from './Shared.styled';
import { getStartFundraisingUrl } from './utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const GfmLeaderboardEmptyState = ({
  siteBaseUrl,
  campaignId
}) => {
  const {
    t
  } = useTranslation('blocks.gfmLeaderboard');
  const startFundraisingUrl = getStartFundraisingUrl(siteBaseUrl, campaignId);
  return /*#__PURE__*/_jsxs(Shared.EmptyStateContainer, {
    children: [/*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsxs(Styled.BadgesContainer, {
        children: [/*#__PURE__*/_jsx(LeaderboardEmptyStateSecond, {}), /*#__PURE__*/_jsx(LeaderboardEmptyFirstPlace, {}), /*#__PURE__*/_jsx(LeaderboardEmptyStateThird, {})]
      }), /*#__PURE__*/_jsx(Styled.EmptyStateTitle, {
        children: t('GfmLeaderboard.title', 'Leaderboard')
      }), /*#__PURE__*/_jsx(Styled.EmptyStateSubtitle, {
        children: t('GfmLeaderboard.emptyStateSubtitle', 'Claim the #1 spot by launching the first fundraiser.')
      }), /*#__PURE__*/_jsx(Styled.StartFundraiserButton, {
        href: startFundraisingUrl,
        children: t('GfmLeaderboard.startFundraiserButton', 'Start your fundraiser')
      })]
    }), /*#__PURE__*/_jsxs(Shared.EmptyListItems, {
      children: [/*#__PURE__*/_jsx(Shared.EmptyListItem, {}), /*#__PURE__*/_jsx(Shared.EmptyListItem, {}), /*#__PURE__*/_jsx(Shared.EmptyListItem, {})]
    })]
  });
};
export default GfmLeaderboardEmptyState;